// utils/fileUtils.ts
export const dataURLToFile = (dataUrl: string, fileName: string): File => {
  const [header, base64String] = dataUrl.split(',');
  const binaryString = atob(base64String);
  const arrayBuffer = new ArrayBuffer(binaryString.length);
  const uint8Array = new Uint8Array(arrayBuffer);
  for (let i = 0; i < binaryString.length; i++) {
    uint8Array[i] = binaryString.charCodeAt(i);
  }

  const blob = new Blob([uint8Array], { type: header.split(';')[0].slice(5) });
  return new File([blob], fileName, { type: blob.type });
};
